import React, { act, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import TenderTable from "./TenderTable";
import axios from "axios";
import VQTable from "./VQTable";
import Tenders from "./FinanceHead/TendersTableFH";
import EMDTable from "./FinanceHead/EMDTable";
import ItemCount from "../../utils/ItemCount";
import { useNavigate } from "react-router-dom";

const FinanceHeadDashboard = () => {
  const [vq, setVq] = useState();
  const [emd, setEmd] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState("TEMD");
  const [isLoading, setIsLoading] = useState(true);
  const [isVQLoading, setIsVQLoading] = useState(true);
  const [pendingActions, setPendingActions] = useState(false);
  const [vendorCount, setVendorCount] = useState(0);
  const [purchaseCount, setPurchaseCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const getVendorCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/item?username=${storedUser.username}&status=TEMD`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setVendorCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getVendorCount();

    const getPurchaseCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/item?username=${storedUser.username}&status=PURCHASE`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setPurchaseCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getPurchaseCount();
  }, []);

  const getVendorTenders = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}&status=${activeTab}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setVq(res.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getEMD = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-emd?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setEmd(res.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getVendorTenders();
  }, [activeTab]);

  useEffect(() => {
    if (localStorage.getItem("pending")) {
      setActiveTab("VQ");
      setPendingActions(true);
      localStorage.removeItem("pending");
    }
  }, []);
  return (
    <Box sx={{ textAlign: "center" }}>
      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              className={`dashboard-btns ${
                activeTab === "TEMD" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("TEMD");
                setIsLoading(true);
              }}
            >
              EMD/CMD Received <ItemCount count={vendorCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "PURCHASE" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("PURCHASE");
                setIsLoading(true);
              }}
            >
              Purchase Received <ItemCount count={purchaseCount} />
            </Button>
          </Box>
          <Box>
            <Button
              className="pending-btn"
              onClick={() => {
                navigate("/dashboard/pending-actions")
                setActiveTab("EMD");
              }}
            >
              My Pending actions
            </Button>
          </Box>
        </Box>
        <Tenders tenders={vq} isLoading={isLoading} activeTab={activeTab} />
      </Box>
    </Box>
  );
};

export default FinanceHeadDashboard;
